import { useConditionValueInputType } from './useConditionValueInputType';
import { FloatValue, IntValue, NumberValue } from '../../../../domain';

export const useToNumberValue = () => {
  const { isFloatInput } = useConditionValueInputType();
  return function toNumberValue(fromValue: string | null): NumberValue | null {
    if (!fromValue) return null;
    const number = isFloatInput
      ? new FloatValue(parseFloat(fromValue))
      : new IntValue(parseInt(fromValue, 10));
    if (Number.isNaN(number.value)) return null;
    return number;
  };
};
